module.exports = __webpack_public_path__ + "media/images/fb-081e1ce28a65fac3bf9f6d7cb43f2df5.png";